/* Inline variant picker + add to cart for product cards */
class CardVariantForm extends HTMLElement {
  constructor() {
    super();
    this.variants = [];
    try {
      this.variants = JSON.parse(this.querySelector('script[type="application/json"]').textContent);
    } catch (e) {
      console.error('card-variant-form: bad variant JSON', e);
    }
    this.selects = Array.from(this.querySelectorAll('select[data-option-index]'));
    this.button = this.querySelector('[data-add-button]');
    this.miniCart = document.querySelector('mini-cart');
    this.card = this.closest('.card-wrapper');

    this.selects.forEach((select) => {
      select.addEventListener('change', this.onChange.bind(this));
      this.syncSwatch(select);
    });
    this.button.addEventListener('click', this.onAdd.bind(this));
    this.resolve();
  }

  syncSwatch(select) {
    const dot = select.parentElement.querySelector('[data-swatch-target]');
    if (!dot) return;
    const opt = select.options[select.selectedIndex];
    const swatch = opt && opt.dataset.swatch;
    dot.style.setProperty('--swatch', swatch || 'transparent');
    dot.classList.toggle('is-empty', !swatch);
  }

  onChange(event) {
    this.syncSwatch(event.target);
    event.target.parentElement.classList.remove('is-error');
    this.resolve();
  }

  /* grey out option values that have no available variant with the other choices made */
  markUnavailable() {
    const chosen = this.selects.map((s) => s.value);
    this.selects.forEach((select, idx) => {
      Array.from(select.options).forEach((opt) => {
        if (!opt.value) return;
        const available = this.variants.some((v) => v.a && v.o[idx] === opt.value &&
          chosen.every((val, j) => j === idx || !val || v.o[j] === val));
        opt.disabled = !available;
        const base = opt.dataset.label || (opt.dataset.label = opt.textContent);
        opt.textContent = available ? base : base + ' (sold out)';
      });
    });
  }

  resolve() {
    const values = this.selects.map((s) => s.value);
    const complete = values.every((v) => v !== '');
    this.selects.forEach((s) => s.parentElement.classList.toggle('is-selected', s.value !== ''));
    this.markUnavailable();

    this.variant = null;
    if (complete) {
      this.variant = this.variants.find((v) => v.o.every((val, i) => val === values[i])) || null;
    }

    if (!complete) {
      this.setButton(this.dataset.addText, false);
      this.button.disabled = false;
    } else if (!this.variant || !this.variant.a) {
      this.setButton(this.dataset.soldoutText, false);
      this.button.classList.remove('is-active');
    } else {
      this.setButton(this.dataset.addText, true);
      this.button.classList.remove('is-active');
    }
  }

  setButton(text, ready) {
    this.button.textContent = text;
    this.button.disabled = !ready;
    this.button.classList.toggle('is-ready', ready);
  }

  onAdd() {
    const missing = this.selects.filter((s) => s.value === '');
    if (missing.length) {
      // highlight the unselected option(s) and show the button in its active state
      missing.forEach((s) => s.parentElement.classList.add('is-error'));
      this.button.classList.add('is-active');
      missing[0].focus();
      return;
    }
    if (!this.variant || !this.variant.a) return;
    const variantId = this.variant.id;

    // Bundle bar present: hold the item there instead of adding to the cart
    // (bundles / gift cards are excluded from the promotion and go straight to the cart)
    const bar = document.querySelector('bundle-bar');
    const excluded = this.card && this.card.hasAttribute('data-bundle-exclude');
    if (bar && !excluded) {
      const img = this.card && this.card.querySelector('.card__media img');
      const priceEl = this.card && (this.card.querySelector('.price .price-item--sale') || this.card.querySelector('.price .price-item--regular'));
      const titleEl = this.card && this.card.querySelector('.card-information__text');
      const colour = this.card && this.card.querySelector('[data-sibling-select]');
      const parts = [];
      if (colour && colour.options.length && colour.options[colour.selectedIndex]) parts.push(colour.options[colour.selectedIndex].textContent.trim());
      this.selects.forEach((s) => parts.push(s.value));
      bar.add({
        variantId: variantId,
        title: titleEl ? titleEl.textContent.trim() : '',
        variantTitle: parts.filter(Boolean).join(' · '),
        image: img ? (img.currentSrc || img.src) : '',
        priceText: priceEl ? priceEl.textContent.trim().replace(/\s+/g, ' ') : '',
        priceCents: this.variant.p || 0,
        url: this.card ? this.card.dataset.productHandle && '/products/' + this.card.dataset.productHandle : ''
      });
      return;
    }

    if (document.body.classList.contains('template-cart') || !theme.shopSettings.cartDrawer) {
      Shopify.postLink(theme.routes.cart_add_url, { parameters: { id: variantId, quantity: 1 } });
      return;
    }

    this.button.disabled = true;
    this.button.classList.add('loading');
    const sections = this.miniCart ? this.miniCart.getSectionsToRender().map((section) => section.id) : [];
    const body = JSON.stringify({ id: variantId, quantity: 1, sections: sections, sections_url: window.location.pathname });

    fetch(theme.routes.cart_add_url, { ...fetchConfig('javascript'), body })
      .then((response) => response.json())
      .then((parsedState) => {
        if (parsedState.status === 422) {
          document.dispatchEvent(new CustomEvent('ajaxProduct:error', { detail: { errorMessage: parsedState.description } }));
        } else {
          this.miniCart && this.miniCart.renderContents(parsedState);
          document.dispatchEvent(new CustomEvent('ajaxProduct:added', { detail: { product: parsedState } }));
        }
      })
      .catch((e) => console.error(e))
      .finally(() => {
        this.button.classList.remove('loading');
        this.button.disabled = false;
      });
  }
}
customElements.define('card-variant-form', CardVariantForm);

document.addEventListener('click', (evt) => {
  const el = evt.target.closest && evt.target.closest('.card-options add-to-cart');
  const bar = document.querySelector('bundle-bar');
  if (!el || !bar) return;
  if (el.closest('[data-bundle-exclude]')) return;
  evt.stopPropagation();
  evt.preventDefault();
  const card = el.closest('.card-wrapper');
  const img = card && card.querySelector('.card__media img');
  const priceEl = card && (card.querySelector('.price .price-item--sale') || card.querySelector('.price .price-item--regular'));
  const titleEl = card && card.querySelector('.card-information__text');
  const colour = card && card.querySelector('[data-sibling-select]');
  bar.add({
    variantId: el.dataset.variantId,
    title: titleEl ? titleEl.textContent.trim() : '',
    variantTitle: colour && colour.options[colour.selectedIndex] ? colour.options[colour.selectedIndex].textContent.trim() : '',
    image: img ? (img.currentSrc || img.src) : '',
    priceText: priceEl ? priceEl.textContent.trim().replace(/\s+/g, ' ') : '',
    priceCents: parseInt(el.dataset.price, 10) || 0,
    url: card && card.dataset.productHandle ? '/products/' + card.dataset.productHandle : ''
  });
}, true);

/* ------------------------------------------------------------------
   Sibling colour switching.
   Reads the colour groups from the Linked Options app (via SSLinkedOptions),
   turns each card colour pill into a dropdown of sibling products, and
   re-renders the card in place (via the card-render section) on change.
------------------------------------------------------------------- */
(function () {
  const htmlCache = {};
  function fetchCardHtml(handle) {
    if (!htmlCache[handle]) {
      htmlCache[handle] = fetch('/products/' + handle + '?section_id=card-render')
        .then((r) => r.text())
        .catch((e) => { delete htmlCache[handle]; throw e; });
    }
    return htmlCache[handle];
  }
  function prefetchSiblings(card, siblings) {
    if (card.dataset.prefetched) return;
    card.dataset.prefetched = '1';
    siblings.forEach((s) => { if (s.handle !== card.dataset.productHandle) fetchCardHtml(s.handle).catch(() => {}); });
  }

  async function populate(card) {
    if (!card || card.dataset.siblingsReady) return;
    card.dataset.siblingsReady = '1';
    const pill = card.querySelector('[data-sibling-pill]');
    const select = card.querySelector('[data-sibling-select]');
    if (!pill || !select) return;

    const siblings = await window.SSLinkedOptions.siblingsFor(card.dataset.productId);
    if (!siblings || siblings.length < 2) return;

    select.innerHTML = '';
    siblings.forEach((s) => {
      const opt = document.createElement('option');
      opt.value = s.handle;
      opt.textContent = s.name + (s.available ? '' : ' (sold out)');
      if (!s.available) opt.disabled = true;
      if (s.hex) opt.dataset.swatch = s.hex;
      if (String(s.id) === String(card.dataset.productId)) opt.selected = true;
      select.appendChild(opt);
    });
    const dot = pill.querySelector('[data-sibling-swatch]');
    const current = select.options[select.selectedIndex];
    if (dot && current && current.dataset.swatch) {
      dot.style.setProperty('--swatch', current.dataset.swatch);
      dot.classList.remove('is-empty');
    }
    pill.hidden = false;
    pill.classList.remove('card-options__pill--single');
    const warm = () => prefetchSiblings(card, siblings);
    pill.addEventListener('mouseenter', warm, { once: true });
    select.addEventListener('focus', warm, { once: true });
    select.addEventListener('touchstart', warm, { once: true, passive: true });
    select.addEventListener('change', () => swapCard(card, select.value));
  }

  async function swapCard(card, handle) {
    if (!handle || handle === card.dataset.productHandle) return;
    card.classList.add('is-swapping');
    try {
      const html = await fetchCardHtml(handle);
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const fresh = doc.querySelector('.card-wrapper--options');
      if (!fresh) throw new Error('card-render section returned no card');

      // keep the original section's image ratio
      const mediaSize = card.dataset.mediaSize || 'square';
      fresh.querySelectorAll('.media--square').forEach((el) => {
        el.classList.remove('media--square');
        el.classList.add('media--' + mediaSize);
      });

      // preload the new main image so the card doesn't flash a grey placeholder
      const img = fresh.querySelector('.card__media img');
      if (img && (img.currentSrc || img.src)) {
        await new Promise((resolve) => {
          const pre = new Image();
          pre.onload = pre.onerror = resolve;
          setTimeout(resolve, 1500);
          if (img.getAttribute('srcset')) pre.srcset = img.getAttribute('srcset');
          if (img.getAttribute('sizes')) pre.sizes = img.getAttribute('sizes');
          pre.src = img.getAttribute('src');
        });
      }

      card.dataset.productId = fresh.dataset.productId;
      card.dataset.productHandle = fresh.dataset.productHandle;
      delete card.dataset.siblingsReady;
      card.innerHTML = fresh.innerHTML;
      // injected markup: skip the theme's scroll-triggered reveal animation and lazy states
      card.querySelectorAll('use-animate').forEach((el) => el.setAttribute('animate', ''));
      card.querySelectorAll('.image-animate').forEach((el) => { el.style.opacity = '1'; el.style.animation = 'none'; el.style.transform = 'none'; });
      card.querySelectorAll('.media-wrapper.loading').forEach((el) => el.classList.remove('loading'));
      card.querySelectorAll('img[is="lazy-image"]').forEach((el) => el.classList.add('loaded'));
      populate(card);
      if (window.loox && typeof window.loox.init === 'function') { try { window.loox.init(); } catch (e) { /* ignore */ } }
    } catch (e) {
      console.error('card swap failed, navigating instead', e);
      window.location.href = '/products/' + handle;
    } finally {
      card.classList.remove('is-swapping');
    }
  }

  function init() {
    document.querySelectorAll('.card-wrapper--options[data-product-id]').forEach(populate);
    new MutationObserver((mutations) => {
      mutations.forEach((m) => m.addedNodes.forEach((n) => {
        if (n.nodeType !== 1) return;
        if (n.matches && n.matches('.card-wrapper--options[data-product-id]')) populate(n);
        if (n.querySelectorAll) n.querySelectorAll('.card-wrapper--options[data-product-id]').forEach(populate);
      }));
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
